import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { feedKeys } from "../model/keys"

registerNotification("question_of_the_day", {
	handle: ({ notification_id, data }, ctx) => {
		showNotification({
			type: "daily-question",
			placement: "home",
			notificationId: notification_id,
			question: data.question,
			origin: "server",
			name: "question_of_the_day",
		})
		ctx.queryClient.invalidateQueries({ queryKey: feedKeys.dailyQuestion() })
	},
	route: () => ({
		to: "/feed",
		search: { tab: "daily-question" as const },
	}),
	routePopup: null,
})
